import { atom, useAtomValue, useSetAtom }     from "jotai";
import { RESET, atomWithReset, useResetAtom } from "jotai/utils";

export const socketState = atomWithReset ();
export const isModerator = atomWithReset (); // initial value to be set with hydration from "isCurrentUserModerator"
export const donationGoal = atomWithReset ();
export const hasUserDonated = atomWithReset ( false );
export const message = atom ( null );

export const useSetIVSConnectionStatus = () => {
	return useSetAtom ( socketState );
};

export const useGetIVSConnectionStatus = () => {
	return useAtomValue ( socketState );
};

export const useSetIsModerator = () => {
	return useSetAtom ( isModerator );
};

export const useGetIsModerator = () => {
	return useAtomValue ( isModerator );
};

export const useSetDonationGoal = () => {
	return useSetAtom ( donationGoal );
};

export const useGetDonationGoal = () => {
	return useAtomValue ( donationGoal );
};

export const useSetMessage = () => {
	return useSetAtom ( message );
};

export const useGetMessage = () => {
	return useAtomValue ( message );
};

export const useSetHasUserDonated = () => {
	return useSetAtom ( hasUserDonated );
};

export const useGetHasUserDonated = () => {
	return useAtomValue ( hasUserDonated );
};

export const useResetAtoms = () => {
	const socketStateReset = useResetAtom ( socketState );
	// const isModeratorReset   = useResetAtom ( isModerator );
	// const dynamicDataReset    = useResetAtom ( dynamicData );
	const donationGoalReset   = useResetAtom ( donationGoal );
	const hasUserDonatedReset = useResetAtom ( hasUserDonated );

	// Call all reset funcitons here
	return () => {
		socketStateReset ( RESET );
		// isModeratorReset ( RESET );
		// dynamicDataReset ( RESET );
		donationGoalReset ( RESET );
		hasUserDonatedReset ( RESET );
	};
};
